import { useMemo, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_DOCTORS, GET_SPECIALTY, GET_REVIEWS } from './homePage.gql';

export const useHomePage = () => {
  const { data: speciatiesData, loading: speciatiesLoading } = useQuery(GET_SPECIALTY, {
    fetchPolicy: 'no-cache',
  });
  const { data: doctorsData, loading: doctorsLoading } = useQuery(GET_DOCTORS);

  const specialties = useMemo(() => {
    if (speciatiesData?.specialties) {
      return speciatiesData?.specialties;
    }
  }, [speciatiesData]);

  const doctors = useMemo(() => {
    if (doctorsData?.doctors) {
      return doctorsData?.doctors
        .filter((item) => item.active)
        .map((item) => ({
          ...item,
          name: `${item.user.firstname} ${item.user.lastname}`,
        }));
    }
  }, [doctorsData]);

  return {
    specialties,
    doctors,
  };
};
